import { createSlice } from '@reduxjs/toolkit';
import AuthService, { ChangePasswordRequestPayload } from '../../../../../../services/auth.service';
import { createAppAsyncThunk } from '../../../../../../common/thunk';
import httpErrorHandling from '../../../../../../utils/httpErrorHandling';

interface ChangePasswordState {
  changed: boolean;
  error: string;
}

export const changePassword = createAppAsyncThunk('auth/changePassword', async (data: ChangePasswordRequestPayload) => {
  return AuthService.changePassword(data).then(response => response.data);
});

const initialState: ChangePasswordState = {
  changed: false,
  error: '',
};
export const changePasswordSlice = createSlice({
  name: 'passwordRecovery',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(changePassword.fulfilled, state => {
      state.changed = true;
    });
    builder.addCase(changePassword.rejected, (state, action) => {
      state.error = httpErrorHandling(action);
    });
    builder.addCase(changePassword.pending, state => {
      state.changed = false;
      state.error = '';
    });
  },
});

export default changePasswordSlice.reducer;
